//#region Imports
import * as fromActions from './../actions';
import { createReducer, on } from '@ngrx/store';
import * as fromModel from '@shared/models';
//#endregion

export interface DashboardState {
    dashData: { [dashId: string]: fromModel.ArticleCharge };

    isLoading: boolean;
    isLoaded: boolean;
    error: fromModel.ErrorModel | null;
}

export const initialState: DashboardState = {
    dashData: {},

    isLoaded: false,
    isLoading: false,
    error: null
};

const dashboardReducerState = createReducer(
    initialState,
    on(fromActions.GET_DASHBOARD_DATA, (state: DashboardState) => {
        return {
            ...state,
            isLoaded: false,
            isLoading: true,
            error: null
        };
    }),
    on(fromActions.GET_DASHBOARD_DATA_SUCCESS, (state: DashboardState, payload: any) => {
        console.log(`payload RED`);
        console.log(payload);

        const getDashData: fromModel.ArticleCharge[] = payload.dashData;

        const entities = getDashData.reduce(
            (
                entity: { [articleChargeId: string]: fromModel.ArticleCharge },
                client: fromModel.ArticleCharge
            ) => {
                return {
                    ...entity,
                    [client.id]: client
                };
            },
            {}
        );
        return {
            ...state,
            dashData: entities,
            isLoaded: true,
            isLoading: false,
            error: null
        };
    }),

    on(fromActions.GET_CLIENT_QUERY_PARAMS_FAIL, (state: DashboardState, payload: any) => {
        const error: fromModel.ErrorModel = payload.error;

        return {
            ...state,
            dashData: {},
            isLoaded: false,
            isLoading: false,
            error
        };
    })
);

/**
 *
 * @param {DashboardState} state
 * @param {DashboardActions} action
 * @return {dashboardReducerState} dashboardReducerState
 */
export function dashboardReducer(state: DashboardState, action: any) {
    return dashboardReducerState(state, action);
}
